import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    alert: {
        alignItems: 'center',
        padding: 10,
        '& .MuiAlert-icon': {
            fontSize: 30,
        },
        fontSize: 15,
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 9999,
    },
});
